import { getComplains, setComplains } from "../Api/PlayerComplains";

export default {
    state: {
        complains: []
    },
    mutations: {
        SET_COMPLAINS(state, payload) {
            state.complains = payload;
        }
    },
    actions: {
        async fetchComplains({ commit }, type) {
            // Переименовано на fetchComplains для большей ясности
            try {
                const response = await getComplains(type);
                commit("SET_COMPLAINS", response.data.problems);
            } catch (error) {
                console.error("Error fetching complains:", error);
                // Здесь можно обработать ошибку, например, вызвать другую мутацию для установки состояния ошибки
            }
        },
        async setComplains({ commit }, payload) {
            const { body, movieType } = payload;
            try {
                const respons = await setComplains(body, movieType);
            } catch (error) {
                console.error("Error setting complains:", error);
                // Здесь можно обработать ошибку, например, вызвать другую мутацию для установки состояния ошибки
            }
        }
    },
    getters: {
        complains(state) {
            // Переименован для согласованности
            return state.complains;
        }
    }
};
